export default {
  RATE: "10", // 率
  FIXED: "20" // 定額
}
